import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type GradescheduleSelectvalue from '@linc-technologies/linced-common/models/assessments/gradeschedule-selectvalue';

// Proto: assessments.GradeScheduleSelect.
export default class GradescheduleSelect extends Fragment {
  declare [Type]: 'assessments/gradeschedule-select';

  @fragmentArray('assessments/gradeschedule-selectvalue')
  declare values: FragmentArray<GradescheduleSelectvalue>;
}
